import { render, staticRenderFns } from "./GroupsPushDepartment.vue?vue&type=template&id=33d1204f&"
import script from "./GroupsPushDepartment.vue?vue&type=script&lang=ts&"
export * from "./GroupsPushDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports